// extracted by mini-css-extract-plugin
export var label = "_fh-2";
export var slideContainer = "_fh-0";
export var slider = "_fh-1";